export default "__VITE_ASSET__$DrrEiz4__"